import Vue from 'vue';
import VueRouter from 'vue-router';
import SelectSite from '@/components/SelectSite.vue';
import NavFormPage from '@/pages/NavigationFormPage.vue';
import NavListPage from '@/pages/ListNavsPage.vue';
import { KSelectFi } from '@kasasa/fbase-components';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'Home',
		component: KSelectFi,
		meta: {
			showSelect: false,
			showAdd: false
		}
	},
	{
		path: '/:clientId',
		name: 'FiHome',
		component: SelectSite,
		meta: {
			showSelect: true,
			showAdd: false
		}
	},
	{
		path: '/:clientId/site/:siteId',
		name: 'NavList',
		component: NavListPage,
		meta: {
			showSelect: true,
			showAdd: true
		}
	},
	{
		path: '/:clientId/site/:siteId/nav/add',
		name: 'NavAdd',
		component: NavFormPage,
		meta: {
			showSelect: true,
			showAdd: false,
			mode: 'add'
		}
	},
	{
		path: '/:clientId/site/:siteId/nav/:id',
		name: 'NavForm',
		component: NavFormPage,
		meta: {
			showSelect: true,
			showAdd: true,
			mode: 'edit'
		}
	},
	{
		path: '*',
		redirect: { name: 'Home' }
	}
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

export default router;
